import { createLucideIcon } from 'lucide-react';

/**
 * Значки вида превью ссылки в Lucide-сетке 24×24: карточка и строки текста, контур без заливки (заливка — у выбранного).
 * Рисуем сами: готовых «большое/маленькое превью» в наборе нет.
 */
export const PreviewLarge = createLucideIcon('preview-large', [
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '3', key: 'frame' }],
  ['path', { d: 'M3 14h18', key: 'image' }],
  ['path', { d: 'M7 18h6', key: 'line' }],
]);

export const PreviewSmall = createLucideIcon('preview-small', [
  ['rect', { x: '3', y: '6', width: '18', height: '12', rx: '3', key: 'frame' }],
  ['rect', { x: '6', y: '9.5', width: '4', height: '5', rx: '1', key: 'thumb' }],
  ['path', { d: 'M13 10.5h5', key: 'line1' }],
  ['path', { d: 'M13 13.5h3', key: 'line2' }],
]);

export const PreviewOff = createLucideIcon('preview-off', [
  ['rect', { x: '3', y: '6', width: '18', height: '12', rx: '3', key: 'frame' }],
  ['path', { d: 'M4 4l16 16', key: 'slash' }],
]);
